import { IResourceComponentsProps, GetListResponse } from "@refinedev/core";
import { AntdInferencer } from "@refinedev/inferencer/antd";
import Cw8List from "components/cw8/Cw8List";

export const SectionPubsList: React.FC<IResourceComponentsProps<GetListResponse<{}>>> = () => {
    const resourceName :string = 'sectionPub';
    return (
        <Cw8List
            resourceName = {resourceName}
        ></Cw8List>
    );
};
